
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Job, TranslationActivity } from '@/domains/global/models'
import { viewOnly } from '@/domains/global/utils'

@Component
export default class JobTabs extends Vue {
  @Prop({ type: String, default: 'details' })
  private readonly value!: string

  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  get tab() {
    return this.value
  }

  set tab(value: string) {
    this.$emit('input', value)
  }

  get isDraft () {
    return this.job.status === 'draft'
  }

  get isViewOnly() {
    return viewOnly(this.job)
  }

  isSubmitted (activity: TranslationActivity) {
    return !activity.isDraft
  }

  tabIconColor (activity: TranslationActivity) {
    return this.isSubmitted(activity) ? 'success' : null
  }

  tabIcon (activity: TranslationActivity) {
    return this.isSubmitted(activity) ? 'check_circle' : 'radio_button_unchecked'
  }

  displayDocumentType(documentType: string) {
    switch (documentType) {
      case 'customer-template':
        return 'Self-Service Template'
      case 'provider-template':
        return 'Standard Template'
      default:
        return 'Document'
    }
  }
}
